import { lazy } from 'react';

export const CustomerFreelancerLinkList = lazy(() => import('./CustomerFreelancerLinkList'));
export const AddCustomerFreelancerLink = lazy(() => import('./AddCustomerFreelancerLink'));
export const CustomerFreelancerLinkDetails = lazy(() => import('./CustomerFreelancerLinkDetails'));
